import React, { useState, useEffect, useCallback,useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { Panel, PanelHeader, PanelBody } from "../../components/panel/panel";
import {
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import Config from "../../Config";
import swal from "sweetalert";
import EmailShare from "react-email-share-link";
import LoaderSpinner from "../../components/Loaderspinner/LoaderSpinner";
// import PersonalQRCodeList from './personal-QRCodeList';
import Select from "react-select";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import {
  GetDominUrl
} from "../../api/apiconfiguration.js";
import { Checkexportdata } from "../../api/packageApi";
import QRCode from "qrcode.react";
import jsPDF from "jspdf";
function PersonalQRCode(props) {
  let history = useHistory();
  const [rolename, setroleName] = useState(
    localStorage.getItem("loginRoleName")
  );
  //const [SelectedArticlesList, setSelectedArticlesList] = useState([]);
  const [PersonalQRCodeList, setPersonalQRCodeList] = useState([]);
  const [subcetgoryList, setsubcetgoryList] = useState([]);
  const [PaggingList, setPaggingList] = useState([]);
  const [modal3, setmodal3] = useState(false);
  const [QrCodeName, setQrCodeName] = useState("");
  const [QrCodeNameError, setQrCodeNameError] = useState("");
  const [OwnerName, setOwnerName] = useState("");
  const [OwnerNameError, setOwnerNameError] = useState("");
  const [CategoryId, setCategoryId] = useState("");
  const [OwnerId, setOwnerId] = useState("");
  const [subcategoryId, setsubcategoryId] = useState("");
  const [subcategoryIdError, setsubcategoryIdError] = useState("");
  const [issubcategoryshow, setissubcategoryshow] = useState(false);
  const [CategoryList, setCategoryList] = useState([]);
  const [SupplierList, setSupplierList] = useState([]);
  const [SupplierId, setSupplierId] = useState("");
  const [CategoryError, setCategoryError] = useState("");

  const [Qrcodestring, setQrcodestring] = useState("");
  const [QrcodeType, setQrcodeType] = useState("");
  const [QrcodeProductname, setQrcodeProductname] = useState("");
  const [Isloading, setIsloading] = useState(false);
  //pagination
  const [PerPageCount, setPerPageCount] = useState(10);
  const [TotalCount, setTotalCount] = useState(0);
  const [TotleCountPublished, setTotleCountPublished] = useState(0);
  const [SortColumnType, setSortColumnType] = useState("Desc");
  const [SortColumn, setSortColumn] = useState("addeddate");
  const [SearchValue, setSearchValue] = useState("");
  const [CurrentPageNo, setCurrentPageNo] = useState(1);
  const [ShowPaggingCount, setShowPaggingCount] = useState(4);
  const [PaginationGroupList, setPaginationGrouplist] = useState([]);
  const [canPreviousPage, setcanPreviousPage] = useState(false);
  const [canNextPage, setcanNextPage] = useState(true);
  const [IsPublished, setIsPublished] = useState("");

  const [userLoaded, setUserLoaded] = useState(false);

  const [subuserlist, setsubuserlist] = useState([]);
  const [selectuserID, setselectuserID] = useState("");
  const [selectuseronlyID, setselectuseronlyID] = useState("");

  const [subToEmail, setsubToEmail] = useState([]);
  const [isToEamil, setisToEamil] = useState(false);

  const [ToemailEmptyError, setToemailEmptyError] = useState("");
  const [isToemailMaltiple, setisToemailMaltiple] = useState(false);
  const domainFrontUrl = useRef("");

  const toggle3 = (Qrcodepath) => {
    if (modal3 === false) {
      if (Qrcodepath?.codeString) {
        if (Qrcodepath?.isCategoryStatic == false) {
          let qrcodestring = domainFrontUrl.current + Qrcodepath?.codeString;
          // setQrcodestring(Config.FrontUrl + Qrcodepath?.codeString);
          setQrcodestring(qrcodestring);
        }
        else{
          setQrcodestring(Qrcodepath?.codeString);
        }
      }
      else {
        setQrcodestring("");
      }

      setQrcodeProductname(Qrcodepath.name);
      setQrcodeType(Qrcodepath.qrCodeType);
    } else {
      setQrcodestring("");
      setQrcodeProductname("");
      setQrcodeType("");
    }
    setmodal3(!modal3);
  };
  useEffect(() => {
    let checkLogin = localStorage.getItem("loginUserID");
    if (
      checkLogin === "" ||
      checkLogin === null ||
      checkLogin === "null" ||
      checkLogin === undefined
    ) {
      history.push("/Login");
    } else {
      getDominUrl();
      GetAllDropdwonArticle();
      if (rolename === "Admin" || rolename === "SuperAdmin") {
        GetadminaandAllsubuser();
      }
    }
  }, []);

  const getDominUrl =async ()=>{
    let response = await GetDominUrl();
    if(response !== null && response.domainName !== null && response.domainName !== ""){
      domainFrontUrl.current = response.domainName;
    }
    else{
      domainFrontUrl.current="";
    }
}

  useEffect(() => {
    getData();
  }, [PerPageCount, SortColumnType, CurrentPageNo, userLoaded]);

  useEffect(() => {
    setPaggingDDL();
    getPaginationGroup();
  }, [TotalCount]);
  const columns = React.useMemo(
    () => [
      {
        Header: "Sr. #",
        accessor: "sr",
        selector: "sr",
        sortable: false,
        Cell: (row) => {
          {
            return (
              <div style={{ width: "40px" }}>
                <span className="mb-0">{row.row.original?.sr}</span>
              </div>
            );
          }
        },
      },
      {
        Header: "Name",
        accessor: "name1",
        selector: "name",
        sortable: true,
        headerClassName: "rt-tr-align-right ",
        Cell: (row) => {
          {
            return row.row.original?.name.length > 0 ? (
              <div className="data-scroll" style={{ width: "70px" }}>
                <p className="mb-0">{row.row.original?.name}</p>
              </div>
            ) : (
              <div className="data-scroll" style={{ width: "70px" }}>
                <p className="mb-0">N/A</p>
              </div>
            );
          }
        },
      },
      {
        Header: "Type",
        accessor: "qrCodeType",
        selector: "qrCodeType",
        sortable: true,
        headerClassName: "rt-tr-align-right",
        Cell: (row) => {
          {
            return (
              <div style={{ width: "60px" }}>
                <p className="mb-0">{row.row.original?.qrCodeType}</p>
              </div>
            );
          }
        },
      },
      {
        Header: "Category",
        accessor: "category",
        selector: "category",
        sortable: true,
        headerClassName: "rt-tr-align-right",
        Cell: (row) => {
          {
            return row.row.original?.categoryDetail?._id != null &&
              row.row.original?.categoryDetail?._id != "" ? (
              <div className="data-scroll" style={{ width: "90px" }}>
                <p className="m-0">
                  {row.row.original?.categoryDetail?.name +
                    "/" +
                    row.row.original?.subCategoryDetail?.name}
                </p>
              </div>
            ) : (
              <div className="data-scroll" style={{ width: "90px" }}>
                <p className="m-0">N/A</p>
              </div>
            );
          }
        },
      },
      {
        Header: "QR Code",
        accessor: "articleQrcode",
        selector: "articleQrcode",
        sortable: false,
        Cell: (row) => {
          //let FullPathQrcode = `${Config.contentUrl+row.row.original.qrCodePath}`;
          return row.row.original?.codeString !== null &&
            row.row.original?.codeString !== "" &&
            row.row.original?.codeString !== undefined ? (
            <div>
              <button
                className={
                  "m-t-5 btn btn-white btn-shadow p-2 border " +
                  (row.row.original?.isPublished === false
                    ? "border-danger"
                    : "")
                }
                onClick={() => {
                  toggle3(row.row.original);
                }}
              >
                <img
                  src="../assets/img/user/QR.png"
                  alt="img"
                  style={{ height: "40px" }}
                  onerror="this.src='../assets/img/new-images/images.png';"
                ></img>
              </button>
              <p className="small text-center m-t-5">
                <b>
                  {row?.row?.original?.isPublished === false ? "Pause" : "Play"}
                </b>
              </p>
            </div>
          ) : row?.row?.original?.isshow === true ? (
            <div>
              <button
                className={
                  "m-t-5 btn btn-white btn-shadow p-2 border " +
                  (row.row.original?.isPublished === false
                    ? "border-danger"
                    : "")
                }
                onClick={(e) => {
                  EditQrcodeDetails(row.row.original?._id);
                }}
              >
                <img
                  src="/assets/img/new-Images/qr-code-scanner.jpg"
                  style={{ height: "40px" }}
                ></img>
              </button>
              <p className="small text-center m-t-5">
                <b>
                  {row?.row?.original?.isPublished === false ? "Pause" : "Play"}
                </b>
              </p>
            </div>
          ) : (
            <>
              <div>
                <button
                  className={
                    "m-t-5 btn btn-white btn-shadow p-2 border " +
                    (row.row.original.isPublished === false
                      ? "border-danger"
                      : "")
                  }
                  onClick={(e) => {
                    swal("  Oops... not allowed ! ");
                  }}
                >
                  <img
                    src="/assets/img/new-Images/qr-code-scanner.jpg"
                    style={{ height: "40px", width: "40px" }}
                  ></img>
                </button>
                <p className="small text-center m-t-5">
                  <b>
                    {row?.row?.original?.isPublished === false
                      ? "Pause"
                      : "Play"}
                  </b>
                </p>
              </div>
            </>
          );
        },
      },
      {
        Header: "Scans",
        accessor: "totalscan",
        selector: "totalscan",
        sortable: true,
        headerClassName: "rt-tr-align-right",
        Cell: (row) => {
          {
            return row.row.original?.totalScans != null &&
              row.row.original?.totalScans != "" ? (
              <div style={{ minWidth: "60px" }}>
                <p className="m-0">{row.row.original?.totalScans}</p>
                {row?.row?.original?.isshow === true ? (
                  <button
                    className="btn btn-link"
                    onClick={() => {
                      gotoreports(row?.row?.original?._id);
                    }}
                  >
                    <img
                      src="../assets/img/user/graph.png"
                      style={{ height: "30px" }}
                    ></img>
                  </button>
                ) : (
                  <button
                    className="btn btn-link"
                    onClick={() => {
                      swal("Oops... not allowed ! ");
                    }}
                  >
                    <img
                      src="../assets/img/user/graph.png"
                      style={{ height: "30px" }}
                    ></img>
                  </button>
                )}
              </div>
            ) : (
              <div style={{ minWidth: "60px" }}>
                <p className="m-0">{"0"}</p>
                {row?.row?.original?.isshow === true ? (
                  <button
                    className="btn btn-link"
                    onClick={() => {
                      gotoreports(row?.row?.original?._id);
                    }}
                  >
                    <img
                      src="../assets/img/user/graph.png"
                      style={{ height: "30px" }}
                    ></img>
                  </button>
                ) : (
                  <button
                    className="btn btn-link"
                    onClick={() => {
                      swal("Oops... not allowed ! ");
                    }}
                  >
                    <img
                      src="../assets/img/user/graph.png"
                      style={{ height: "30px" }}
                    ></img>
                  </button>
                )}
              </div>
            );
          }
        },
      },

      {
        Header: "Dynamic / Static",
        accessor: "dynamicstatic",
        selector: "dynamicstatic",
        sortable: true,
        headerClassName: "rt-tr-align-right",
        Cell: (row) => {
          {
            return row.row.original?.isCategoryStatic === true ? (
              <div className="" style={{ width: "130px" }}>
                <p className="m-0">{"Static"}</p>
              </div>
            ) : (
              <div className="" style={{ width: "130px" }}>
                <p className="m-0">{"Dynamic"}</p>
              </div>
            );
          }
        },
      },

      {
        Header: " Created Date",
        accessor: "createdDate",
        selector: "addeddate",
        sortable: true,
        Cell: (row) => {
          let date = new Date(row.row.original?.createdDate);
          let dateMDY = `${date.getDate()}-${date.getMonth() + 1
            }-${date.getFullYear()}`;
          return (
            <p className="mb-0" style={{ width: "110px" }}>
              {dateMDY}
            </p>
          );
        },
      },
      {
        Header: "Owner",
        accessor: "owner",
        selector: "owner",
        sortable: false,
        Cell: (row) => {
          let FullOwnerpath = `${Config.contentUrl + row.row.original.ownerImage
            }`;
          return (
            //<img src={FullPathQrcode} alt="img" style={{ height: '40px' }}></img>
            <div className="data-scroll">
              <img
                src={FullOwnerpath}
                className="rounded-circle"
                style={{ height: "40px", width: "40px", objectFit: "cover" }}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = "../assets/img/new-images/images.png";
                }}
              ></img>
              {/* <img src="../assets/img/user/user-1.jpg" alt="img" style={{ height: '40px', }} className='rounded-circle'></img> */}
              <p>{row.row.original.ownerName}</p>
            </div>
          );
        },

        // Cell: row => {
        //     //let FullPathQrcode = `${Config.contentUrl+row.row.original}`;
        //     return (
        //         //<img src={FullPathQrcode} alt="img" style={{ height: '40px' }}></img>
        //         <div className='data-scroll'>
        //             <img src="../assets/img/user/user-1.jpg" alt="img" style={{ height: '40px', borderRadius: '100px' }} onerror="this.src='../assets/img/new-images/images.png';"></img>
        //             <p>Helena Rout </p>
        //         </div>

        //     )
        // }
      },
      {
        Header: " Actions",
        accessor: "col13",
        sortable: false,
        Cell: (row) => {
          return (
            <div style={{ width: "80px" }}>
              {row?.row?.original?.isshow === true ? (
                <>
                  <button
                    type="button"
                    className="btn btn-primary  mr-2"
                    onClick={(e) => {
                      EditQrcodeDetails(row.row.original?._id);
                    }}
                  >
                    <i className="ion ion-md-create "></i>
                  </button>
                  <UncontrolledButtonDropdown>
                    <DropdownToggle className="btn btn-success btn btn-warning ellipsis-btn">
                      <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem
                        onClick={(e) => {
                          row.row.original?.isPublished === false
                            ? PersonalPlay(row.row.original?._id)
                            : PersonalAllreadyplay();
                        }}
                      >
                        <i className="fas fa-play m-r-10"></i>
                        Play
                      </DropdownItem>
                      <DropdownItem divider></DropdownItem>
                      <DropdownItem
                        onClick={(e) => {
                          row.row.original?.isPublished === false
                            ? PersonalAllreadypush()
                            : PersonalPause(row.row.original?._id);
                        }}
                      >
                        <i className="fas fa-pause m-r-10"></i>
                        Pause
                      </DropdownItem>
                      <DropdownItem divider></DropdownItem>
                      <DropdownItem
                        onClick={(e) => {
                          DeleteQrCodeDetails(row.row.original?._id);
                        }}
                      >
                        <i className="fas fa-trash m-r-10"></i>
                        Delete
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledButtonDropdown>
                </>
              ) : (
                <>
                  {" "}
                  <button
                    type="button"
                    className="btn btn-primary btn-sm mr-2"
                    onClick={(e) => {
                      swal("  Oops... not allowed ! ");
                    }}
                  >
                    <i className="ion ion-md-create "></i>
                  </button>
                  <UncontrolledButtonDropdown>
                    <DropdownToggle className="btn btn-warning ellipsis-btn btn-sm">
                      <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem
                        onClick={(e) => {
                          swal("  Oops... not allowed ! ");
                        }}
                      >
                        <i className="fas fa-play m-r-10"></i>
                        Play
                      </DropdownItem>
                      <DropdownItem divider></DropdownItem>
                      <DropdownItem
                        onClick={(e) => {
                          swal("  Oops... not allowed ! ");
                        }}
                      >
                        <i className="fas fa-pause m-r-10"></i>
                        Pause
                      </DropdownItem>
                      <DropdownItem divider></DropdownItem>
                      <DropdownItem
                        className="text-danger"
                        onClick={(e) => {
                          swal("  Oops... not allowed ! ");
                        }}
                      >
                        <i className="fas fa-trash m-r-10"></i>
                        Delete
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledButtonDropdown>
                </>
              )}
            </div>
          );
        },
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,

    //canPreviousPage,
    //canNextPage,
    pageOptions,

    //gotoPage,
    //nextPage,

    //setPageSize,
    //state: { pageIndex, pageSize },
    toggleAllRowsSelected,
    selectedFlatRows,
    state: { selectedRowIds },
  } = useTable(
    {
      columns,
      data: PersonalQRCodeList,
      manualPagination: true,
      sortable: false,
      manualSortBy: true,
    },
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        // Let's make a column for selection
        {
          _id: "selection",
          // The header can use the table's getToggleAllRowsSelectedProps method
          // to render a checkbox
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <div>
              <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
            </div>
          ),
          // The cell can use the individual row's getToggleRowSelectedProps method
          // to the render a checkbox
          Cell: ({ row }) => (
            <div>
              <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...columns,
      ]);
    }
  );
  const EditQrcodeDetails = (QrcodeIdObj) => {
    if (QrcodeIdObj === "") {
      props.history.push("Login1");
    } else {
      // history.push({
      //   pathname: "/qrcodemanagement/personal-Editpersonalqrcode",
      //   state: { QrcodeDetailsID: QrcodeIdObj },
      // });
      history.push({
        pathname: "/personal-Editpersonalqrcode",
        state: { QrcodeDetailsID: QrcodeIdObj },
      });
    }
  };
  const IndeterminateCheckbox = React.forwardRef(
    ({ indeterminate, ...rest }, ref) => {
      const defaultRef = React.useRef();
      const resolvedRef = ref || defaultRef;

      React.useEffect(() => {
        resolvedRef.current.indeterminate = indeterminate;
      }, [resolvedRef, indeterminate]);

      return (
        <>
          <input type="checkbox" ref={resolvedRef} {...rest} />
        </>
      );
    }
  );
  const gotoreports = (personalID) => {
    // history.push({
    //   pathname: "/dashboard/reports",
    //   state: { ActivePill: "3", PersonalID: personalID },
    // });
    history.push({
      pathname: "/reports",
      state: { ActivePill: "3", PersonalID: personalID },
    });
  };
  const gotoPage = () => {
    if (CurrentPageNo > 1) {
      setCurrentPageNo((CurrentPageNo) => CurrentPageNo - 1);
      let temp = Math.ceil(CurrentPageNo - 1);
      if (temp === 1) {
        setcanPreviousPage(false);
      } else {
        setcanPreviousPage(true);
        setcanNextPage(true);
      }
    }
  };
  const ArticleDetailsSearch = (itemSearchValue) => {
    // const itemlength = itemSearchValue.length;
    // if (itemlength > 2) {
    //     getData();
    // }
  };

  const isNumber = (e) => {
    const re = /^[0-9\b]+$/;
    if (e.target.value === "" || re.test(e.target.value)) {
      if (e.target.value === "") {
        setPerPageCount(0);
        setCurrentPageNo(1);
      } else {
        setPerPageCount(e.target.value);
        setCurrentPageNo(1);
      }
    }
  };
  const handleColumnSort = (event) => {
    setCurrentPageNo(1);
    setcanPreviousPage(false);
    setcanNextPage(true);
    setSortColumn(event.selector);
    let SortType = "Desc";
    if (SortColumnType == "Desc") {
      SortType = "Asc";
    }
    setSortColumnType(SortType);
  };
  const nextPage = () => {
    setCurrentPageNo((CurrentPageNo) => CurrentPageNo + 1);
    setcanPreviousPage(true);
    let PerPageCountobj = Math.ceil(TotalCount / PerPageCount);
    let temp = Math.ceil(CurrentPageNo + 1);
    if (temp === PerPageCountobj) {
      setcanNextPage(false);
    }
  };
  const getPaginationGroup = () => {
    if (TotalCount > 0) {
      let PerPageCountobj = Math.ceil(TotalCount / PerPageCount);
      let start = Math.floor((CurrentPageNo - 1) / PerPageCount) * PerPageCount;
      let LastPageNo = Math.ceil(TotalCount / PerPageCount);
      if (PerPageCountobj === 1) {
        setcanPreviousPage(false);
        setcanNextPage(false);
      }
      let testArray = [];
      for (var tt = 1; tt <= TotalCount; tt++) {
        if (
          tt >= CurrentPageNo - ShowPaggingCount &&
          tt <= CurrentPageNo + ShowPaggingCount
        ) {
          if (tt <= LastPageNo) {
            testArray.push(tt);
          }
        }
      }
      setPaginationGrouplist(testArray);
    }
  };

  const setPaggingDDL = () => {
    var testDDL = [];

    if (TotalCount <= 10) {
      testDDL = [10, TotalCount];
    } else if (TotalCount <= 20) {
      testDDL = [10, 20, TotalCount];
    } else if (TotalCount <= 30) {
      testDDL = [10, 20, 30, TotalCount];
    } else if (TotalCount <= 50) {
      testDDL = [10, 20, 30, 50, TotalCount];
    } else if (TotalCount <= 100) {
      testDDL = [10, 20, 30, 50, 100, TotalCount];
    } else if (TotalCount <= 200) {
      testDDL = [10, 20, 30, 50, 100, 200, TotalCount];
    } else if (TotalCount <= 300) {
      testDDL = [10, 20, 30, 50, 100, 200, 300, TotalCount];
    } else if (TotalCount <= 400) {
      testDDL = [10, 20, 30, 50, 100, 200, 300, 400, TotalCount];
    } else if (TotalCount <= 500) {
      testDDL = [10, 20, 30, 50, 100, 200, 300, 400, 500, TotalCount];
    }

    setPaggingList(testDDL);
  };

  const changePage = (event) => {
    const pageNumber = Number(event.target.textContent);
    if (pageNumber === 1) {
      setcanPreviousPage(false);
      setcanNextPage(true);
    } else {
      setcanPreviousPage(true);
    }
    setCurrentPageNo(pageNumber);
    let PerPageCountobj = Math.ceil(TotalCount / PerPageCount);

    if (pageNumber === PerPageCountobj) {
      setcanNextPage(false);
    } else {
      setcanNextPage(true);
    }
  };

  const handlePageCountChange = (event) => {
    setPerPageCount(event);
    setCurrentPageNo(1);
    if (event >= TotalCount) {
      setcanPreviousPage(false);
      setcanNextPage(false);
    } else {
      setcanPreviousPage(false);
      setcanNextPage(true);
    }
  };

  const SearchFilter = () => {
    setCurrentPageNo(1);
    getData();
  };

  const getData = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let subUserIDList = localStorage.getItem("subUserIDList");
    setTotalCount(0);
    setIsloading(true);
    document.body.style.overflow = "hidden";
    fetch(
      Config.apiUrl +
      "QrCodeResourceController/SearchPagination?SortingColumnName=" +
      SortColumn +
      "&AscDesc=" +
      SortColumnType +
      "&PageNo=" +
      CurrentPageNo +
      "&PageSize=" +
      PerPageCount +
      "&qrCodeName=" +
      QrCodeName +
      "&categoryId=" +
      CategoryId +
      "&ownerid=" +
      selectuseronlyID +
      "&subcategoryId" +
      subcategoryId +
      "&isPublished=" +
      IsPublished,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          subUserCompanyID: subUserIDList,
          Authorization: "Bearer " + Auth0token,
        },
      }
    )
      .then((resp1) => {
        resp1.json().then((result) => {
          if (result !== null) {
            if (result.totalCount != 0) {
              setTotalCount(result.totalCount);
              setPersonalQRCodeList(result.qrCodeListResource);
              setTotleCountPublished(result?.totalPublishedCount);
            } else {
              setTotalCount(0);
              setPersonalQRCodeList([]);
              setTotleCountPublished(0);
            }
          } else {
            setTotalCount(0);
            setPersonalQRCodeList([]);
            setTotleCountPublished(0);
          }
          setIsloading(false);
          document.body.style.overflow = "auto";
        });
      })
      .catch((error) => {
        setIsloading(false);
        document.body.style.overflow = "auto";
        console.error("There was an error!", error);
      });
  };
  const GetadminaandAllsubuser = async () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl + "UserCompany/GetadminaandAllsubuser?isadmin=" + false,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((responseJson) => {
        setsubuserlist(responseJson);
      })
      .catch((error) => {
        // setIsloading(false)
        // document.body.style.overflow = 'auto';
        console.log(error);
        setsubuserlist([]);
      });
  };
  const GetAllDropdwonArticle = () => {
    let loginid = localStorage.getItem("loginUserID");
    let EmaptyArrry = [];
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(Config.apiUrl + "Category/CategoryListwithsubcategory", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }).then((resp1) => {
      resp1.json().then((result) => {
        if (result.length > 0) {
          setCategoryList(result);
        } else {
          setCategoryList(EmaptyArrry);
        }
      });
    });
  };
  const onChangeCategory = (event) => {
    if (CategoryList.length > 0);
    {
      var subCategoryDetailList = CategoryList.find(
        (x) => x._id === event.target.value
      );
      if (subCategoryDetailList != undefined) {
        setsubcetgoryList(subCategoryDetailList.subCategoryModelList);
      } else {
        setsubcetgoryList([]);
      }
    }
    setCategoryId(event.target.value);
    setCategoryError("");
  };
  const onChangeSubCategory = (event) => {
    setsubcategoryId(event.target.value);
    setsubcategoryIdError("");
  };
  const onChangeQrCodeName = (event) => {
    setQrCodeNameError("");
    setQrCodeName(event.target.value);
  };
  const onChangeOwner = (event) => {
    setOwnerNameError("");
    setOwnerName(event.target.value);
  };
  const handleChangeCategory = () => {
    if (issubcategoryshow === true) {
      setsubcategoryId();
    }
    setissubcategoryshow(!issubcategoryshow);
  };

  const ExportDeatlis = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let TotalIteam = [];
    for (let index = 0; index < selectedFlatRows.length; index++) {
      TotalIteam.push(selectedFlatRows[index].original._id);
    }
    if (TotalIteam.length > 0) {
      fetch(Config.apiUrl + "QrCodeResourceController/Export", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(TotalIteam),
      })
        .then((response) => response.blob())
        .then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.href = url;
          a.download = "ExportPersonalQrcode.csv";
          document.body.appendChild(a);
          a.click();
          a.remove();
          deselectAllRows();
        });
    } else {
      swal("Sorry!", "pleace select personal qrcode !", "error");
    }
  };
  const deselectAllRows = useCallback(() => {
    Object.keys(selectedRowIds).forEach((key, index) => {
      selectedRowIds[key] = false;
    });
    toggleAllRowsSelected(false);
  }, [selectedRowIds, toggleAllRowsSelected]);
  const onSelcetdQrcodeDelete = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let TotalIteam = [];
    // for (let index = 0; index < selectedFlatRows.length; index++) {
    //     TotalIteam.push(selectedFlatRows[index].original._id);
    // }
    for (let index = 0; index < selectedFlatRows.length; index++) {
      if (selectedFlatRows[index].original?.isshow === true) {
        TotalIteam.push(selectedFlatRows[index].original._id);
      } else {
        swal("Oops... not allowed ! ");
        return;
      }
    }
    if (TotalIteam.length > 0) {
      swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this Qr Code !",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          fetch(
            Config.apiUrl +
            "QrCodeResourceController/MultipleDelete?id[]=" +
            TotalIteam,
            {
              method: "DELETE",
              headers: {
                "Content-Type": "application/json",
                userCompanyID: loginid,
                Authorization: "Bearer " + Auth0token,
              },
              body: JSON.stringify(TotalIteam),
            }
          ).then((result) => {
            result.json().then((resp) => {
              if (resp === true) {
                GetAllDropdwonArticle();
                getData();
                swal("Congratulations! Your data deleted successfully.", {
                  icon: "success",
                });
              } else {
                swal("Your Article  is safe!");
              }
            });
          });
        }
      });
    } else {
      swal("Sorry!", "pleace select personal qrcode !", "error");
    }
  };

  const DeleteQrCodeDetails = (seleteQRcodeID) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      seleteQRcodeID != null &&
      seleteQRcodeID != "" &&
      seleteQRcodeID != undefined
    ) {
      swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this QRCode !",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          fetch(
            Config.apiUrl +
            "QrCodeResourceController/Delete?id=" +
            seleteQRcodeID,
            {
              method: "DELETE",
              headers: {
                "Content-Type": "application/json",
                userCompanyID: loginid,
                Authorization: "Bearer " + Auth0token,
              },
            }
          ).then((result) => {
            result.json().then((resp) => {
              if (resp === true) {
                GetAllDropdwonArticle();
                getData();
                swal("Congratulations! Your QrCode delete successfully.", {
                  icon: "success",
                });
              } else {
                swal("Your QRCode  is safe!");
              }
            });
          });
        }
      });
    }
  };

  const downloadQRCodeArticle = () => {
    // const qrCodeURL = document.getElementById('qrCodeEl')
    //     .toDataURL("image/png")
    //     .replace("image/png", "image/octet-stream");
    // var doc = new jsPDF("p", "pt", "c6");
    // doc.setFontSize(22);
    // doc.text(20, 30, QrcodeProductname);
    // doc.setFontSize(10);
    // // doc.text(20, 80, "Title: " + row.title);
    // // doc.text(20, 100, "Years: " + row.years);
    // doc.addImage(qrCodeURL, "JPEG", 100, 100, 150, 200);
    // doc.save("QrCode.pdf");

    const qrCodeURL = document
      .getElementById("qrCodeEl")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    console.log(qrCodeURL);
    let aEl = document.createElement("a");
    aEl.href = qrCodeURL;
    aEl.download = "QR_Code.png";
    document.body.appendChild(aEl);
    aEl.click();
    document.body.removeChild(aEl);
  };

  const printQrcode = () => {
    const qrCodeURL = document
      .getElementById("qrCodeEl")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    var doc = new jsPDF("p", "pt", "A4");
    doc.setFontSize(22);
    doc.text(20, 30, QrcodeProductname);
    doc.setFontSize(10);
    // doc.text(20, 80, "Title: " + row.title);
    // doc.text(20, 100, "Years: " + row.years);
    doc.addImage(qrCodeURL, "JPEG", 100, 100, 200, 200);
    //doc.save("QrCode.pdf");
    doc.autoPrint();
    doc.output("dataurlnewwindow");
  };

  const ClereHedersearch = (e) => {
    e.preventDefault();
    setQrCodeName("");
    setOwnerName("");
    setCategoryId("");
    setsubcategoryId("");
    setIsPublished("");
    setissubcategoryshow(false);
    setselectuseronlyID("");
    setselectuserID("");
    setUserLoaded(!userLoaded);
    // getData()
  };

  const PersonalAllreadyplay = () => {
    swal("Your Personal Qrcode already Play !");
  };
  const PersonalAllreadypush = () => {
    swal("Your Personal Qrcode already push !");
  };
  const PersonalPlay = (seleteArticleID) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      seleteArticleID != null &&
      seleteArticleID != "" &&
      seleteArticleID != undefined
    ) {
      fetch(
        Config.apiUrl +
        "QrCodeResourceController/UpdatePublish?id=" +
        seleteArticleID +
        "&isPublish=" +
        true,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            getData();
            swal(
              "Congratulations! Your Personal Qrcode is Publish successfully.",
              {
                icon: "success",
              }
            );
          } else {
            swal("Your Personal Qrcode not Publish successfully.!");
          }
        });
      });
    }
  };

  const PersonalPause = (seleteArticleID) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      seleteArticleID != null &&
      seleteArticleID != "" &&
      seleteArticleID != undefined
    ) {
      fetch(
        Config.apiUrl +
        "QrCodeResourceController/UpdatePublish?id=" +
        seleteArticleID +
        "&isPublish=" +
        false,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            getData();
            swal(
              "Congratulations! Your Personal Qrcode is Pause successfully.",
              {
                icon: "success",
              }
            );
          } else {
            swal(" Your Personal Qrcode not Pause successfully.!");
          }
        });
      });
    }
  };
  const onChangePublished = (event) => {
    console.log(event.target.value);
    setIsPublished(event.target.value);
  };

  const toggleToEmail = () => {
    setisToemailMaltiple(false);
    setToemailEmptyError("");
    setsubToEmail([""]);
    setisToEamil(!isToEamil);
  };

  const QRCodePersonalSend = async (e) => {
    const unique = [...new Set(subToEmail)];
    if (subToEmail.length !== unique.length) {
      setisToemailMaltiple(true);
      return;
    }
    const found = subToEmail.find(
      (element) => element === "" || element === "" || element === null
    );
    if (found != undefined) {
      setToemailEmptyError("All filled is required");
      return;
    }
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    const qrCodeURL = await document
      .getElementById("qrCodeEl")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let filelist = [];
    let filedata = {
      path: "png",
      sourceURL: "png",
      data: qrCodeURL,
    };
    filelist.push(filedata);
    let ContactHelpModel = {
      UserCompanyID: loginid,
      name: ".png",
      // "To": "rprajapati@eagletechsolutions.uk",
      subject: "Qrcode",
      body: QrcodeProductname,
      attachFileList: filelist,
      ToEmailList: subToEmail,
    };
    fetch(Config.apiUrl + "EmailQueue/SendMailOfQrcodesend", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
      body: JSON.stringify(ContactHelpModel),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((resp1) => {
        console.log("123=====>", resp1);
        if (resp1 === true) {
          toggleToEmail();
          swal("Thank You", "Successfully  send email", "success");
        } else {
          swal("Sorry", "Pleace  Contact Admin.", "error");
        }
      });
  };

  const SubToEmailremoveClick = (i) => {
    setToemailEmptyError("");
    setisToemailMaltiple(false);
    let subToEmailTemp = [...subToEmail];
    if (subToEmailTemp != null && subToEmailTemp !== undefined) {
      subToEmailTemp.splice(i, 1);
    }
    setsubToEmail(subToEmailTemp);
  };
  const SubToEmailhandleChange = (i) => (event) => {
    setToemailEmptyError("");
    setisToemailMaltiple(false);
    let subToemaillistnewTemp = [...subToEmail];
    subToemaillistnewTemp[i] = event.target.value;
    setsubToEmail(subToemaillistnewTemp);
    const unique = [...new Set(subToemaillistnewTemp)];
    if (subToemaillistnewTemp.length !== unique.length) {
      setisToemailMaltiple(true);
    }
  };
  const SubToEmailaddClick = () => {
    setsubToEmail((n) => [...n, ""]);
  };

  const createSubToEmailUI = () => {
    return subToEmail.map((el, i) => (
      <div key={i} className="removeSection">
        <input
          type="text"
          className="form-control mr-2"
          //maxlength="50"
          placeholder="Enter To Email (Maximum 50 Character)"
          value={el || ""}
          onChange={SubToEmailhandleChange(i)}
        />
        {i > 0 ? (
          <a
            href="javascript:void(0)"
            onClick={(e) => {
              SubToEmailremoveClick(i);
            }}
            className="btn btn-danger"
          >
            <i class="fas fa-trash"></i>
          </a>
        ) : (
          <></>
        )}
      </div>
    ));
  };
  return (
    <div>
      <LoaderSpinner isrefresh={Isloading} />
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item">
          <a href="/home">Home</a>
        </li>
        {/* <li className="breadcrumb-item"><a href="./PersonalQRCode">QR Code management </a></li> */}
        <li className="breadcrumb-item active">Personal QR Code</li>
      </ol>
      <h1 className="page-header">Personal QR Code </h1>
      <div className="mb-2">
        <div className="row justify-content-end">
          <Link
            className="btns btn btn-primary search-btn  mr-2 mb-1"
            // to="/qrcodemanagement/personal-CreateQRCode"
            to="/personal-CreateQRCode"
          >
            <i class="fas fa-lg fa-fw m-r-5 fa-plus-square icon"></i>
            Add new
          </Link>
          <div className="btns btn-group  mr-2  mb-1">
            <button
              className="btn btn-green"
              // onClick={(e) => { ExportDeatlis() }}
              onClick={async (e) => {
                try {
                  let response = await Checkexportdata();
                  if (response === true || response === "true") {
                    ExportDeatlis();
                  } else {
                    swal(
                      "oops!",
                      "Sorry! to increase your export data enabled   .",
                      "warning"
                    );
                  }
                } catch (error) {
                  console.log("error!", error);
                }
              }}
            >
              <i class="fas  fa-sm fa-fw m-r-5 fa-download icon"></i>
              Export{" "}
            </button>
          </div>
          <button
            type="button"
            className="btns btn  btn-danger  mr-2 mb-1"
            onClick={onSelcetdQrcodeDelete}
          >
            <i className="far fa-lg fa-fw m-r-5 fa-trash-alt icon"></i>
            Delete (selected)
          </button>
        </div>
      </div>
      {/* <div className="row d-flex justify-content-end mb-2">
                <div className="col-md-12 row justify-content-end">
                    <button to="/qrcodemanagement/personal-CreateQRCode" type="button" className="btns btn btn-primary btn-sm mr-2  ">
                        <i class='fas m-r-5 fa-plus-square icon'></i>
                        Add new
                    </button>
                    <div className="btns btn-group  mr-2 ">
                        <button className="btn btn-green" onClick={(e) => { ExportDeatlis() }}>
                            <i class="fas  fa-sm fa-fw m-r-5 fa-download icon"></i>
                            Export  </button>
                    </div>
                    <button type="button" className="btns btn btn-danger mr-2 mb-1" onClick={onSelcetdQrcodeDelete}>
                        <i className="far fa-lg fa-fw m-r-5 fa-trash-alt icon"></i>
                        Delete (selected)
                    </button>
                    <button type="button" className="btns btn  btn-danger  mr-2 mb-1" onClick={onSelcetdQrcodeDelete}>
                        <i className="far fa-lg fa-fw m-r-5 fa-trash-alt icon"></i>
                        Delete (selected)
                    </button>
                </div>
            </div> */}
      <Panel>
        <PanelHeader>
          <div>
            <h4 className="mb-0 text-light">
              <i className="fas fa-fw m-r-10 fa-search"></i> Search
            </h4>
          </div>
        </PanelHeader>
        <PanelBody>
          <div className="row mt-2">
            <div className="col-xl-6 px-4">
              <form action="javascript:void(0);" method="POST">
                <fieldset>
                  <div className="form-group row m-b-15 d-flex align-items-center">
                    <label className="col-md-4 col-form-label product-lable">
                      QR Code name{" "}
                    </label>
                    <div className="d-none d-md-block d-lg-block">:</div>
                    <div className="col-md-7">
                      <input
                        type="text"
                        className="form-control input-height"
                        placeholder="Enter Qr code name"
                        value={QrCodeName}
                        onChange={(e) => {
                          onChangeQrCodeName(e);
                        }}
                      />
                    </div>
                  </div>
                  <div className="form-group row m-b-15 d-flex align-items-center">
                    <label className="col-md-4 col-form-label product-lable">
                      Category{" "}
                    </label>
                    <div className="d-none d-md-block d-lg-block">:</div>
                    <div className="col-md-7">
                      <select
                        class="default-select2 form-control"
                        value={CategoryId}
                        onChange={onChangeCategory}
                      >
                        <option value="" selected>
                          --- Select Category ---
                        </option>
                        {CategoryList.map((item) => (
                          <option value={item._id}>{item.name}</option>
                        ))}
                        {CategoryError.length > 0 && (
                          <span style={{ color: "red", marginLeft: 6 }}>
                            {CategoryError}
                          </span>
                        )}
                      </select>
                    </div>
                  </div>

                  <div className="form-group row m-b-10 d-flex align-items-center">
                    <label className="col-md-4 col-form-label product-lable">
                      Search sub Category
                    </label>
                    <div className="d-none d-md-block d-lg-block">:</div>
                    <div className="col-md-7">
                      <div className="form-check">
                        <input
                          className="form-check-input checkbox-label"
                          type="checkbox"
                          checked={issubcategoryshow}
                          onChange={handleChangeCategory}
                          id="defaultCheckbox"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="defaultCheckbox"
                        ></label>
                      </div>
                    </div>
                  </div>
                  {issubcategoryshow === true ? (
                    <div className="form-group row m-b-15 d-flex align-items-center">
                      <label className="col-md-4 col-form-label product-lable">
                        sub Category{" "}
                      </label>
                      <div className="d-none d-md-block d-lg-block">:</div>
                      <div className="col-md-7">
                        <select
                          class="default-select2 form-control"
                          value={subcategoryId}
                          onChange={onChangeSubCategory}
                        >
                          <option value="" selected>
                            --- Select Category ---
                          </option>
                          {subcetgoryList.map((item) => (
                            <option value={item._id}>{item.name}</option>
                          ))}
                          {subcategoryIdError.length > 0 && (
                            <span style={{ color: "red", marginLeft: 6 }}>
                              {subcategoryIdError}
                            </span>
                          )}
                        </select>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </fieldset>
              </form>
            </div>
            <div className="col-xl-6 px-4">
              <form action="javascript:void(0);" method="POST">
                <fieldset>
                  {/* <div className="form-group row m-b-15 d-flex align-items-center">
                                        <label className="col-md-4 col-form-label product-lable">Owner</label>
                                        <div className='d-none d-md-block d-lg-block'>:</div>
                                        <div className="col-md-7">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter User name"
                                                value={OwnerName}
                                                onChange={(e) => { onChangeOwner(e) }} />
                                        </div>
                                    </div> */}

                  <div className="form-group row m-b-15 d-flex align-items-center">
                    <label className="col-md-4 col-form-label product-lable">
                      Published{" "}
                    </label>
                    <div className="d-none d-md-block d-lg-block">:</div>
                    <div className="col-md-7">
                      <select
                        class="default-select2 form-control"
                        value={IsPublished}
                        onChange={onChangePublished}
                      >
                        <option value=""> Select Published</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                    </div>
                  </div>

                  {rolename === "Admin" || rolename === "SuperAdmin" ? (
                    <div className="form-group row m-b-15 d-flex align-items-center">
                      <label className="col-md-4 col-form-label product-lable">
                        User
                      </label>
                      <div className="d-none d-md-block d-lg-block">:</div>
                      <div className="col-md-7">
                        <Select
                          search
                          options={subuserlist}
                          value={selectuserID}
                          onChange={(e) => {
                            setselectuseronlyID(e.value);
                            setselectuserID(e);
                          }}
                          placeholder="Choose login user"
                        />
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </fieldset>
              </form>
            </div>
          </div>
          <div className="row  justify-content-center">
            <button
              type="button"
              className="btn btn-primary search-btn d-flex align-items-center"
              onClick={SearchFilter}
            >
              <i className="fas fa-lg fa-fw m-r-10 fa-search "></i>
              Search
            </button>
            <button
              type="button"
              className="btn btn-danger ml-2"
              onClick={(e) => {
                ClereHedersearch(e);
              }}
            >
              Reset
            </button>
          </div>
        </PanelBody>
      </Panel>
      {/* <PersonalQRCodeList /> */}
      <Panel>
        <PanelHeader>
          <h4 className="text-white mb-0">Personal QR codes</h4>
        </PanelHeader>
        <PanelBody>
          <div className="row">
            <div className="col-xl-8 d-flex align-items-center">
              {/* <button className="btn btn-default  m-r-10">All Personal QR Code</button> */}
              <div className="form-group  d-flex mb-0 m-r-10 align-items-center allPublishedinput">
                <label className="col-form-label p-0">All</label>
                <input
                  type="email"
                  className="form-control"
                  id="exampleInputEmail2"
                  onKeyUp={(e) => {
                    ArticleDetailsSearch(e.target.value);
                  }}
                  placeholder={"" + TotalCount + ""}
                />
              </div>
              <div className="form-group  d-flex mb-0 m-r-10 align-items-center allPublishedinput">
                <label className="col-form-label p-0"> Published</label>
                <input
                  type="email"
                  className="form-control"
                  id="exampleInputEmail2"
                  onKeyUp={(e) => {
                    ArticleDetailsSearch(e.target.value);
                  }}
                  placeholder={"" + TotleCountPublished + ""}
                />
              </div>
              {/* <div className="form-group  d-flex mb-0 m-r-10 align-items-center">
                                <h5 className="col-form-label p-0 text-center mr-2 mb-0"> Show</h5>
                                <input type="text" className="form-control col-md-8" style={{ width: '40px' }} id="exampleInputEmail2" value={PerPageCount} onChange={isNumber} placeholder={"" + TotalCount + ""} />

                            </div> */}
              <div className="display">
                <select
                  className="form-control"
                  value={PerPageCount}
                  onChange={(e) => {
                    handlePageCountChange(Number(e.target.value));
                  }}
                >
                  {PaggingList.map((pageSize) => {
                    return pageSize == TotalCount ? (
                      <option key={pageSize} value={pageSize}>
                        Show All
                      </option>
                    ) : (
                      <option key={pageSize} value={pageSize}>
                        Show {pageSize}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </div>
          <div class="table-responsive mt-3">
            <table
              class="table table-bordered table-striped text-center text-break"
              {...getTableProps()}
            >
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr
                    {...headerGroup.getHeaderGroupProps()}
                    style={{ textAlign: "center" }}
                  >
                    {headerGroup.headers.map((column) => (
                      <th
                        className="align-middle"
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        <div
                          class="d-flex table-header"
                          style={{ minWidth: "" }}
                        >
                          <span>{column.render("Header")}</span>
                          <span
                            onClick={(e) => {
                              handleColumnSort(column);
                            }}
                          >
                            {column.sortable ? (
                              SortColumn === column.selector ? (
                                SortColumnType == "Desc" ? (
                                  <i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>
                                ) : (
                                  <i className="fa fa-sort-up fa-fw f-s-14 text-blue"></i>
                                )
                              ) : (
                                <i className="fa fa-sort fa-fw f-s-14 opacity-3"></i>
                              )
                            ) : (
                              ""
                            )}
                          </span>
                        </div>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row, i) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <td {...cell.getCellProps()} className="align-middle">
                            {cell.render("Cell")}{" "}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div class="d-flex align-items-center justify-content-between flex-wrap ">
            <div>
              Showing{" "}
              <strong>
                {CurrentPageNo} of {Math.ceil(TotalCount / PerPageCount)}
              </strong>{" "}
              entries
            </div>

            <ul class="pagination justify-content-end flex-wrap align-items-center mt-3">
              <li class="page-item">
                {canPreviousPage == true ? (
                  <a
                    class="page-link mr-2"
                    href="javascript:void(0);"
                    onClick={() => gotoPage(0)}
                  >
                    Previous
                  </a>
                ) : (
                  <a
                    class="page-link mr-2"
                    href="javascript:void(0);"
                    disabled={true}
                  >
                    Previous
                  </a>
                )}
              </li>

              {PaginationGroupList.map((item, index) => (
                <li>
                  <button
                    key={index}
                    onClick={changePage}
                    className={`btn ml-2 ${CurrentPageNo === item ? "page-link-1" : "btn-white"
                      }`}
                  >
                    <span>{item}</span>
                  </button>
                </li>
              ))}

              <li class="page-item ml-2">
                {canNextPage == true ? (
                  <a
                    class="page-link"
                    href="javascript:void(0);"
                    onClick={() => nextPage()}
                  >
                    Next
                  </a>
                ) : (
                  <a
                    class="page-link"
                    href="javascript:void(0);"
                    disabled={true}
                  >
                    Next
                  </a>
                )}
              </li>
            </ul>
          </div>
        </PanelBody>
        <Modal isOpen={modal3} toggle={toggle3}>
          <ModalHeader toggle={toggle3} className="modalheader">
            <h5 className="text-white mb-0">Personal QR codes</h5>
          </ModalHeader>
          <ModalBody>
            <div className="d-flex justify-content-center mt-2">
              {/* <h5 className='mb-0'>{QrcodeType}</h5> */}
              <h5 className="mb-0 ">{QrcodeProductname}</h5>
            </div>
            {/* <div className='row justify-content-center mt-2'>
                            <div className='col-xs-5 text-center  titlebgcontainer'>
                                <h5 className='mb-0 ' >{QrcodeProductname}</h5>
                            </div>
                        </div> */}

            <div className="d-flex justify-content-center mt-2">
              {/* <img src="../assets/img/user/QR.png" alt="img" style={{ maxHeight: '250px' }} onerror="this.src='../assets/img/new-images/images.png';"></img> */}

              <QRCode value={Qrcodestring} id="qrCodeEl" size={210} />
            </div>

            <div className="d-flex justify-content-center mt-4">
              <button
                type="submit"
                className="btn btn-warning  m-r-5 m-b-5"
                onClick={() => {
                  printQrcode();
                }}
              >
                Print
              </button>
              <button
                type="submit"
                className="btn btn-warning m-b-5 m-r-5"
                onClick={() => {
                  downloadQRCodeArticle();
                }}
              >
                Download
              </button>
              <button
                type="submit"
                className="btn btn-warning m-r-5 m-b-5"
                onClick={() => {
                  toggleToEmail();
                }}
              >
                Send
              </button>
              {/* <button type="submit" className="btn btn-warning m-r-5 m-b-5">Send  </button> */}
              {/* <EmailShare email="pupadhyay@egaltechsolutions.uk" subject="Your subject" body="Your message, including the link to this page">
                                {link => (
                                    <a href={link} data-rel="external"><button type="submit" className="btn btn-warning m-b-5 ">Send</button></a>
                                )}
                            </EmailShare> */}
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={isToEamil} toggle={toggleToEmail}>
          <ModalHeader toggle={toggleToEmail} className="modalheader">
            <h5 className="text-white mb-0">To Email</h5>
          </ModalHeader>
          <ModalBody>
            <div className="col-md-12">
              <label
                htmlFor="exampleInputPassword1"
                className="mt-2 d-flex align-items-center"
              >
                <h5 className="mb-0">Add To Email</h5>
                <button
                  type="button"
                  className="m-l-10 btn btn-link"
                  onClick={SubToEmailaddClick}
                >
                  <i className="fas fa-lg fa-fw fa-plus-circle text-success"></i>
                </button>
              </label>
            </div>
            <div className="form-group">
              {createSubToEmailUI()}
              {isToemailMaltiple === true ? (
                <span style={{ color: "red", marginLeft: 6 }}>
                  {"Email id dublicate"}
                </span>
              ) : (
                <></>
              )}
              {ToemailEmptyError.length > 0 && (
                <span style={{ color: "red", marginLeft: 6 }}>
                  {ToemailEmptyError}
                </span>
              )}
            </div>
            <div className="d-flex justify-content-center">
              <button
                type="button"
                onClick={() => {
                  QRCodePersonalSend();
                }}
                className="btn btn-sm btn-primary m-r-5 shadow-add "
              >
                Send Email
              </button>
              <button
                type="button"
                onClick={() => {
                  toggleToEmail();
                }}
                className="btn btn-sm btn-danger shadow-add "
              >
                Cancel
              </button>
            </div>
          </ModalBody>
        </Modal>
      </Panel>
    </div>
  );
}

export default PersonalQRCode;
